import {Component, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {RouterOutlet} from "@angular/router";
import {ModalConfirmComponent} from "@app/_components/modal-confirm/modal-confirm.component";
import {FormGroup} from "@angular/forms";
import {NgbModalOptions, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: 'app-base-modal',
    imports: [
        RouterOutlet
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './base-modal.component.html'
})
export class BaseModalComponent {
    @ViewChild('confirmationModal') modalConfirmComponent!: ModalConfirmComponent;
    formGroup!: FormGroup;
    modalRef!: NgbModalRef;
    modalOptions: NgbModalOptions;
    savingData: boolean = false;

    constructor() {
        this.modalOptions = {
            modalDialogClass: "modal-dialog-centered",
            backdrop: "static",
        }
    }

    onDismiss() {
        this.modalConfirmComponent.confirmIfDirty(this.formGroup, () => {
            this.resetFormGroup();
            this.modalRef.dismiss();
        });
    }

    protected resetFormGroup() {
        this.formGroup.reset();
    }
}
